import React, { useState } from 'react';
import './App.css';

function App() {
  const bookName = "THE POWER TO RECLAIM YOUR MIND";
  const authorName = "GODFRED AKPAN";
  const whatsappLink = "https://wa.me/+2349036709916"; 
  const bookCoverUrl = "https://ucarecdn.com/10148d79-cce7-4050-aefd-1e9c9d44c6ba/PreviewCover9.png";
  const authorImageUrl = "https://ucarecdn.com/286e9acb-8918-41fc-a8d8-95868f262e46/IMG_5271.jpg"; // Replace with actual author image URL

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="app-container">
      {/* Book Details Section */}
      <div className="book-container">
        <div className="book-content">
          <h3 className="subtitle">A DETAILED MESSAGE <br /> TO THE CONTEMPORARY SOCIETY</h3>
          <p className="small-text">About change, faith, reality, enlightenment, and the human experience.</p>
          
          <h1 className="book-title">{bookName}</h1>
          <h2 className="author-name">{authorName}</h2>

          {/* Pricing Section */}
          <div className="pricing-section">
            <h3>Price starts from <span className="highlight">₦4,999</span></h3>
            <ul>
              <li><strong>Ebook:</strong> ₦4,999</li>
              <li><strong>Paperback (White):</strong> ₦6,999</li>
              <li><strong>Paperback (Cream):</strong> ₦9,999</li>
            </ul>
          </div>

          {/* Call to Action Buttons */}
          <div className="cta-buttons">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="order-btn">
              Order on WhatsApp
            </a>
            <button className="view-cover-btn" onClick={() => setIsModalOpen(true)}>
              View Book Cover
            </button>
          </div>
        </div>
      </div>

      {/* Learning Section */}
      <section className="learning-section">
        <h2>What You Will Learn:</h2>
        <ul>
          <li>How to identify and eliminate negative thought patterns.</li>
          <li>Techniques to build mental clarity and focus.</li>
          <li>Strategies to develop emotional resilience.</li>
          <li>Steps to create a life of purpose and fulfillment.</li>
        </ul>
      </section>

      {/* About the Author Section */}
      <section className="author-section">
        <h2>About the Author</h2>
        <div className="author-content">
          <img src={authorImageUrl} alt="Godfred Akpan" className="author-image" />
          <div className="author-text">
            <p>
              <strong>Godfred Akpan</strong> is a passionate thinker, writer, and speaker dedicated to
              helping individuals reclaim their minds and live purpose-driven lives. With a deep 
              understanding of faith, self-awareness, and personal growth, he has spent years 
              guiding people towards enlightenment and inner transformation.
            </p>
            <p>
              His book, <em>"The Power to Reclaim Your Mind"</em>, is a culmination of his insights 
              into how modern society shapes our thoughts and how we can break free from limiting 
              beliefs to achieve mental clarity and fulfillment.
            </p>
          </div>
        </div>
      </section>

      {/* Modal for Book Cover */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-modal" onClick={() => setIsModalOpen(false)}>×</button>
            <img src={bookCoverUrl} alt="Book Cover" className="book-image" />
          </div>
        </div>
      )}

      {/* Footer Section */}
      <footer className="footer">
        <p style={{ color: '#a52a2a' }}>© {new Date().getFullYear()} Godfred Akpan. All Rights Reserved.</p>
      </footer>
    </div>
  );
}

export default App;
